module.exports = __webpack_public_path__ + "static/media/Icon-blue-person.bc07170e.svg";